import RequestAccess from './RequestAccess.container';

export default RequestAccess;
